export const API_ROUTES = {
    //Get api call
    GET_ENABLE_FEU_DOWNLOAD_XML: (vesselMstId) => `api/FuelEuMonitoringPlan/fueleu-thetis-enable/${vesselMstId}`,
    GET_DOWNLOAD_FEU_FILE: (vesselMstId) => `api/FuelEuMonitoringPlan/export-fueleu-xml/${vesselMstId}`,
    GET_MEASURING_EQUIPMENTS_NAMES: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/GetMeasuringEquipments?vesselMstId=${vesselMstId}`,
    GET_FEU_DOWNLOAD_PDF: (vesselMstId) => `/api/MrvMonitoringPlan/DownloadPdf/${vesselMstId}`,
    GET_B3_PREFILL_B5: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b32/getById${vesselMstId}`,
    GET_EMISSION_SOURCE_NAMES: (vesselMstId) => `api/FuelEuMonitoringPlan/emissionsourcenames/${vesselMstId}`,
    CLONE_FEU: () => `api/CloneMonitoringPlan/CloneMonitoringPlan`,
    FEU_Validate_plan: (type,vesselMstId) => `api/CloneMonitoringPlan/IsCloneEnabled?planType=FuelEu&vesselMstId=${vesselMstId}`,
    Get_FEU_Sections_By_PlanType: (planType) => `api/CloneMonitoringPlan/GetOptions?planType=${planType}`,
    //A-section
    A: `api/FuelEuMonitoringPlan/partA`,

    //B-Section
    B1: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b1/${vesselMstId}`,
    B2: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b2/${vesselMstId}`,
    B3: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b3/${vesselMstId}`,
    B31: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b31/${vesselMstId}`,
    B32: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b32/${vesselMstId}`,
    B33: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b33/${vesselMstId}`,
    B34: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b34/${vesselMstId}`,
    B35: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b35/${vesselMstId}`,
    B36: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b36/${vesselMstId}`,
    B4: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b4/${vesselMstId}`,
    B5: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b5/${vesselMstId}`,
    B6: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b6/${vesselMstId}`,
    B7: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b7/${vesselMstId}`,
    B8: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b8/${vesselMstId}`,
    B9: (vesselMstId) => `api/FuelEuMonitoringPlan/partb/b9/${vesselMstId}`,

    //C-section
    C1: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c1/${vesselMstId}`,
    C11: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c11/${vesselMstId}`,
    C12: (vesselMstId) => `api/FuelEuMonitoringPlan/partc12/c12/${vesselMstId}`,
    C13: (vesselMstId) => `api/FuelEuMonitoringPlan/partc13/c13/${vesselMstId}`,
    C14: (vesselMstId) => `api/FuelEuMonitoringPlan/partc14/c14/${vesselMstId}`,
    C15: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c15/${vesselMstId}`,
    C16: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c16/${vesselMstId}`,
    C17: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c17/${vesselMstId}`,
    C18: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c18/${vesselMstId}`,
    C21: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c21/${vesselMstId}`,
    C22: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c22/${vesselMstId}`,
    C23: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c23/${vesselMstId}`,
    C31: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c31/${vesselMstId}`,
    C32: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c32/${vesselMstId}`,
    C33: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c33/${vesselMstId}`,
    C34: (vesselMstId) => `api/FuelEuMonitoringPlan/partc/c34/${vesselMstId}`,

    //D-Section
    D1: (vesselMstId) => `api/FuelEuMonitoringPlan/partd/d1/${vesselMstId}`,
    D2: (vesselMstId) => `api/FuelEuMonitoringPlan/partd/d2/${vesselMstId}`,
    D3: (vesselMstId) => `api/FuelEuMonitoringPlan/partd/d3/${vesselMstId}`,
    D4: (vesselMstId) => `api/FuelEuMonitoringPlan/partd/d4/${vesselMstId}`,
    D5: (vesselMstId) => `api/FuelEuMonitoringPlan/partd/d5/${vesselMstId}`,

    //E-Section
    E1: (vesselMstId) => `api/FuelEuMonitoringPlan/parte/e1/${vesselMstId}`,
    E2: (vesselMstId) => `api/FuelEuMonitoringPlan/parte/e2/${vesselMstId}`,
    E3: (vesselMstId) => `api/FuelEuMonitoringPlan/parte/e3/${vesselMstId}`,
    E4: (vesselMstId) => `api/FuelEuMonitoringPlan/parte/e4/${vesselMstId}`,
    E5: (vesselMstId) => `api/FuelEuMonitoringPlan/parte/e5/${vesselMstId}`,
    E6: (vesselMstId) => `api/FuelEuMonitoringPlan/parte/e6/${vesselMstId}`,
    E7: (vesselMstId) => `api/FuelEuMonitoringPlan/parte/e7/${vesselMstId}`,
    E8: (vesselMstId) => `api/FuelEuMonitoringPlan/parte/e8/${vesselMstId}`,

    //F-Section
    F1: (vesselMstId) => `/api/FuelEuMonitoringPlan/partf/f1/${vesselMstId}`,
    F2: (vesselMstId) => `/api/FuelEuMonitoringPlan/partf/f2/${vesselMstId}`,
}




